import '../stylesheets/account_modal.css';

import React, {
  createRef,
  forwardRef,
  useImperativeHandle,
  useState,
} from 'react';
import { Modal } from 'react-bootstrap';

import Account from '../components/Account';

const closeButtonStyle = {
  position: 'absolute',
  top: 20,
  right: 20,
  width: 32,
  height: 32,
  border: 'none',
  borderRadius: '50%',
  background: 'rgba(0, 0, 0, 0.6)',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  zIndex: 1,
};

const defaultOptions = () => ({
  onClose: undefined,
  headerPaddings: { right: 52 },
  showLogoutButton: false,
  saveButtonVariant: 'primary',
  showHeaderSaveButton: false,
  showBottomSaveButton: true,
});

export const accountModalRef = createRef();

const AccountModal = forwardRef(({ centered = true }, ref) => {
  const [visible, setVisible] = useState(false);
  const [options, setOptions] = useState(defaultOptions);

  const hide = () => {
    setVisible(false);
    setOptions(defaultOptions());
  };

  const handleClose = () => {
    if (typeof options.onClose === 'function') options.onClose();
    hide();
  };

  useImperativeHandle(ref, () => ({
    show: (nextOptions = {}) => {
      setOptions({
        ...defaultOptions(),
        ...nextOptions,
        headerPaddings: {
          ...defaultOptions().headerPaddings,
          ...(nextOptions.headerPaddings || {}),
        },
      });
      setVisible(true);
    },
    hide,
  }));

  return (
    <Modal
      show={visible}
      onHide={handleClose}
      centered={centered}
      dialogClassName='account-modal-dialog'>
      <Modal.Body style={{ padding: 0, position: 'relative' }}>
        <button
          type='button'
          onClick={handleClose}
          aria-label='Close'
          className='modal-close-button'
          style={closeButtonStyle}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'>
            <path
              d='M3 3L13 13M13 3L3 13'
              stroke='white'
              strokeWidth='2'
              strokeLinecap='round'
            />
          </svg>
        </button>
        <Account
          headerPaddings={options.headerPaddings}
          showLogoutButton={options.showLogoutButton}
          saveButtonVariant={options.saveButtonVariant}
          showHeaderSaveButton={options.showHeaderSaveButton}
          showBottomSaveButton={options.showBottomSaveButton}
          initialActiveTab={options.initialActiveTab}
          paymentMethodStatus={options.paymentMethodStatus}
        />
      </Modal.Body>
    </Modal>
  );
});

AccountModal.displayName = 'AccountModal';

export default AccountModal;

export const openAccountModal = (options = {}) => {
  accountModalRef.current?.show(options);
};
